export default __webpack_public_path__ + "ce2bfb8c188c6cb539b3743dc5670448.svg";